<script setup>
import { useQuasar, useDialogPluginComponent } from 'quasar'
import { reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import apiUser from '../../../api/user.api'

const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const $q = useQuasar()
const { t } = useI18n()

const loading = ref(false)
const data = reactive({
  oldPassword:  '',
  newPassword: '',
  newPasswordAgain: ''
})

async function submit () {
  if (data.newPassword !== data.newPasswordAgain) {
    return $q.notify({ message: t('settings.password.mismatch'), type: 'negative' })
  }
  try {
    loading.value = true
    await apiUser.changePassword({
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
      newPasswordAgain: data.newPasswordAgain
    })
    onDialogOK()
    $q.notify({ message: t('settings.password.changed'), type: 'positive' })
  } catch (error) {
    $q.notify({ message: error?.data?.error, type: 'negative' })
  } finally {
    loading.value = false
  }
}

</script>

<template lang='pug'>
.settings-general-change-password
  q-dialog(ref='dialogRef' persistent)
    q-card.overflow-hidden(style='width: 500px; max-width: 80vw;')
      q-form(@submit='submit')
        q-card-section
          .row
            .text-h6 {{ t('settings.password.change') }}
        q-separator
        q-card-section.scroll(style='max-height: 70vh;')
          q-input.q-mb-md(
            type='password'
            stack-label
            outlined
            v-model='data.oldPassword'
            :label="t('settings.password.old')"
            :rules=`[ val => val && val.length || '' ]`
            no-error-icon
            hide-bottom-space
            hide-hint
            autofocus
          )
          q-input.q-mb-md(
            type='password'
            stack-label
            outlined
            v-model='data.newPassword'
            :label="t('settings.password.new')"
            :rules=`[ val => val && val.length || '' ]`
            no-error-icon
            hide-bottom-space
            hide-hint
            autofocus
          )
          q-input.q-mb-md(
            type='password'
            stack-label
            outlined
            v-model='data.newPasswordAgain'
            :label="t('settings.password.confirm')"
            :rules=`[ val => val && val.length || '' ]`
            no-error-icon
            hide-bottom-space
            hide-hint
            autofocus
          )
        q-separator
        q-card-actions(align='right')
          q-btn(
            flat
            unelevated
            color='grey'
            @click='onDialogCancel'
            :label="t('actions.cancel')")
          q-btn(
            flat
            type='submit'
            unelevated
            color='primary'
            :label="t('actions.save')")
      q-inner-loading(:showing='loading')
</template>